/**
 * Console methods captured as bound references so app LogLayer transports write
 * to the host console without depending on later `globalThis.console`
 * reassignment.
 */
const originalConsole = globalThis.console;

export const ORIGINAL_CONSOLE: Console = {
  ...originalConsole,
  debug: Function.prototype.bind.call(originalConsole.debug, originalConsole),
  error: Function.prototype.bind.call(originalConsole.error, originalConsole),
  info: Function.prototype.bind.call(originalConsole.info, originalConsole),
  log: Function.prototype.bind.call(originalConsole.log, originalConsole),
  warn: Function.prototype.bind.call(originalConsole.warn, originalConsole),
} as Console;
